import React from "react";
import { Datagrid, TextField, ArrayField, useRecordContext } from "react-admin";
import Box from "@mui/material/Box";

import { Region } from "../../infrastructure/types";

import { TotalField } from "./total_field";
import { commonStyles } from "../common_styles";

const styles = {
  header: {
    display: "none",
  },
  tbody: {
    borderTop: "1px solid rgba(224, 224, 224, 1)",
  },
};

export const RegionField = (props: any) => {
  const { regions } = props;
  const record = useRecordContext();

  if (record === undefined) {
    return null;
  }

  const filterRegions = regions.filter((region: Region) => {
    return region.is_active && region.prefecture_id === record["id"];
  });

  if (filterRegions.length === 0) {
    return null;
  }

  return (
    <ArrayField {...props}>
      <Box sx={commonStyles.showPageInnerDatagrid}>
        <Datagrid bulkActionButtons={false} sx={{ tbody: styles.tbody, headerCell: styles.header }} empty={null}>
          <TextField source="label" sortable={false} />
          <TotalField source="total" sortable={false} />
        </Datagrid>
      </Box>
    </ArrayField>
  );
};
